var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98438 0.984497C3.7195 0.988634 3.46709 1.09762 3.28254 1.28753C3.09799 1.47745 2.99637 1.73277 3 1.99747V2.99678H2C0.906937 2.99678 0 3.90309 0 4.9954V18.9858C0 20.0781 0.906937 20.9844 2 20.9844H16C17.0931 20.9844 18 20.0781 18 18.9858V4.9954C18 3.90309 17.0931 2.99678 16 2.99678H15V1.99747C15.0018 1.86377 14.9768 1.73107 14.9264 1.60721C14.876 1.48336 14.8012 1.37087 14.7065 1.27642C14.6118 1.18196 14.4991 1.10745 14.375 1.05731C14.251 1.00717 14.1182 0.982409 13.9844 0.984497C13.7195 0.988634 13.4671 1.09762 13.2825 1.28753C13.098 1.47745 12.9964 1.73277 13 1.99747V2.99678H5V1.99747C5.00183 1.86377 4.9768 1.73107 4.92638 1.60721C4.87597 1.48336 4.80119 1.37087 4.70649 1.27642C4.61179 1.18196 4.49908 1.10745 4.37504 1.05731C4.25101 1.00717 4.11816 0.982409 3.98438 0.984497ZM2 7.99333H16V18.9858H2V7.99333ZM10 11.9906C9.448 11.9906 9 12.4383 9 12.9899V15.9878C9 16.5394 9.448 16.9871 10 16.9871H13C13.552 16.9871 14 16.5394 14 15.9878V12.9899C14 12.4383 13.552 11.9906 13 11.9906H10Z",
    fill: "#0044c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.c4b509e97ea3156b5086ebc32865f4aa.svg";
export { ForwardRef as ReactComponent };